


























































import { Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component({})
export default class extends Mixins(MyList) {
  data1: any[] = [];

  data2: any[] = [];

  loading1 = false;

  loading2 = false;

  columns: any[] = [
    { title: "版本号", dataIndex: "user_version" },
    { title: "描述", dataIndex: "user_desc" },
    { title: "来源小程序" },
    { title: "最近上传开发者" },
    { title: "最近提交时间", scopedSlots: { customRender: "create_time" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  columns1: any[] = [
    { title: "版本号", dataIndex: "user_version" },
    { title: "描述", dataIndex: "user_desc" },
    { title: "templateID", dataIndex: "template_id" },
    { title: "添加到模板库时间", scopedSlots: { customRender: "create_time" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  columns2: any[] = [
    { title: "版本号", dataIndex: "user_version" },
    { title: "描述", dataIndex: "user_desc" },
    { title: "templateID", dataIndex: "template_id" },
    { title: "添加到模板库时间", scopedSlots: { customRender: "create_time" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  async loadTemplateDraft() {
    this.loading = true;
    const res = await this.$store.dispatch("oplatformapps/gettemplatedraftlist", {});
    if (res && res.Data && res.Data != "{}") {
      this.data = res.Data;
    }

    this.loading = false;
  }

  async loadTemplate() {
    this.loading1 = true;
    const res = await this.$store.dispatch("oplatformapps/gettemplatelist", {
      template_type: "0"
    });
    if (res && res.Data && res.Data != "{}") {
      this.data1 = res.Data;
    }

    this.loading1 = false;
  }

  async loadTemplate1() {
    this.loading2 = true;
    const res = await this.$store.dispatch("oplatformapps/gettemplatelist", {
      template_type: "1"
    });
    if (res && res.Data && res.Data != "{}") {
      this.data2 = res.Data;
    }

    this.loading2 = false;
  }

  handleDeleteCodeTemplate(templateId: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要删除该小程序代码模板吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/deletecodetemplate", {
          template_id: templateId
        });

        if (res && res.Message && res.Message == "success") {
          this.$message.success(res.Message);
          this.loadTemplate();
          this.loadTemplate1();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  addtotemplate(draftId: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要添加到模板库吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/addtotemplate", {
          draft_id: draftId
        });

        if (res && res.Message && res.Message == "success") {
          this.$message.success(res.Message);
          this.loadTemplateDraft();
          this.loadTemplate();
          this.loadTemplate1();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  mounted() {
    this.loadTemplateDraft();
    this.loadTemplate();
    this.loadTemplate1();
  }
}
